import axios from './common/axios';

export default {
  fetchOne(params, callback) {
    axios
      .get('/shop/getProduct', {
        params: {
          _id: params._id,
          is_cart_empty: params.is_cart_empty,
          is_login: params.is_login,
          premium_plan_welcome_point: params.premium_plan_welcome_point,
          premium_plan_recontract_extra_point: params.premium_plan_recontract_extra_point,
          has_welcoming_gift_coupon: params.has_welcoming_gift_coupon
        }
      })
      .then(function(res) {
        if (res.data.errors) {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  registerRestockNotification(params, callback) {
    axios
      .post('/shop/register_restock_notification', {
        sku_id: params.sku_id,
        product_id: params.product_id,
        email: params.email,
        _csrf: params._csrf
      })
      .then(function(res) {
        if (res.data.errors) {
          return callback(res.data.errors);
        }
        if (res.data.status === 'ng') {
          return callback(new Error('An error occurred.'));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  unregisterRestockNotification(params, callback) {
    axios
      .post('/shop/unregister_restock_notification', {
        sku_id: params.sku_id,
        product_id: params.product_id,
        email: params.email,
        _csrf: params._csrf
      })
      .then(function(res) {
        if (res.data.errors) {
          return callback(res.data.errors);
        }
        if (res.data.status === 'ng') {
          return callback(new Error('An error occurred.'));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  }
};
